import { render, staticRenderFns } from "./contextmenu.vue?vue&type=template&id=2a4dc6e5&scoped=true"
import script from "./contextmenu.vue?vue&type=script&lang=js"
export * from "./contextmenu.vue?vue&type=script&lang=js"
import style0 from "./contextmenu.vue?vue&type=style&index=0&id=2a4dc6e5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4dc6e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a4dc6e5')) {
      api.createRecord('2a4dc6e5', component.options)
    } else {
      api.reload('2a4dc6e5', component.options)
    }
    module.hot.accept("./contextmenu.vue?vue&type=template&id=2a4dc6e5&scoped=true", function () {
      api.rerender('2a4dc6e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/navBars/tagsView/contextmenu.vue"
export default component.exports